import { useState, useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from 'reducers/rootReducer'
import { useParams } from 'react-router-dom'

export interface CartFloatingIconProps {}

export const useCartFloatingIcon = (props: CartFloatingIconProps) => {
  const { restaurantName } = useParams<{
    restaurantName: string
  }>()
  const [isAnimating, setIsAnimating] = useState(false)
  const cartItems = useSelector((state: RootState) => state.orders.cart)

  const prevCountRef = useRef(cartItems?.length || 0)

  useEffect(() => {
    const currentCount = cartItems?.length || 0

    if (currentCount > prevCountRef.current) {
      setIsAnimating(true)

      const timer = setTimeout(() => {
        setIsAnimating(false)
      }, 400)

      return () => clearTimeout(timer)
    }

    prevCountRef.current = currentCount
  }, [cartItems])

  return {
    ...props,
    restaurantName,
    numberOfItems: cartItems?.length || 0,
    isAnimating,
  }
}
